import script from "./FinalBalanceFCST.vue?vue&type=script&setup=true&lang=js"
export * from "./FinalBalanceFCST.vue?vue&type=script&setup=true&lang=js"

import "./FinalBalanceFCST.vue?vue&type=style&index=0&id=684f8512&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-684f8512"]])

export default __exports__